import { gql } from '@apollo/client';

export const ELIGIBLE_DISCOUNT_QUERY = gql`
  query getEligibleDiscount {
    account {
      discountPromotionEndDate
    }
  }
`;
